'use strict';

var React = require('react');

var SvgLegalFilledMajor = function SvgLegalFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 3.75a2.25 2.25 0 0 0-2.25 2.25v3.5c0 .414.336.75.75.75h2.25v4.5a2 2 0 0 0 1.567 1.953c.196-.128.43-.203.683-.203a.75.75 0 0 0 .75-.75v-1c0-.69.56-1.25 1.25-1.25h5.25v-8.25a1.5 1.5 0 0 0-1.5-1.5h-8.75Zm.75 2.25a.75.75 0 0 0-1.5 0v2.75h1.5v-2.75Zm2.625 1.5c0-.345.28-.625.625-.625h3a.625.625 0 1 1 0 1.25h-3a.625.625 0 0 1-.625-.625Zm.625 2.375a.625.625 0 1 0 0 1.25h3a.625.625 0 1 0 0-1.25h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.605 16.5a2 2 0 0 1-1.855 1.25h7.75a1.5 1.5 0 0 0 1.5-1.5v-1.5h-7.25v1c0 .265-.052.518-.145.75Z"
  }));
};
SvgLegalFilledMajor.displayName = "LegalFilledMajor";

exports.SvgLegalFilledMajor = SvgLegalFilledMajor;
